import {getField, updateField} from "vuex-map-fields";
import Repository from "@/repository";
const MESSAGE_API = "/report";
// ----------------------- STATE ------------------------- //

const state = {
  report_data: [],
  currentIndex: -1,
  isDownloadFinished: false,
  viewData: {
    vehicles: [
      {
        name: "Vehicle Alerts",
        desc: "Vehicle Alerts and Violations",
        url: "vehiclealertReport",
        disabled: false,
      },
      {
        name: "Vehicle Alerts Summary",
        desc: "Alert Summary of Vehicles",
        url: "alertSummarytReport",
        disabled: false,
      },
      {
        name: "Safety Driver League",
        desc: "Safety Driver League Pitting Drivers against each other",
        url: "safetyDriverLeagueReport",
        disabled: false,
      },
      {
        name: "Vehicle List",
        desc: "Listing of all basic vehicle information",
        url: "vehicleListReport",
        disabled: true,
      },
      {
        name: "Vehicle Details",
        desc: "Listing of full vehicle profiles & details",
        url: "vehicleDetailsReport",
        disabled: true,
      },
      {
        name: "Operating Cost Summary",
        desc: "Summary of costs associated with vehicles",
        url: "operatingCostSummary",
        disabled: true,
      },
      {
        name: "Total Cost Trend",
        desc: "Analysis of total vehicle cost per meter over time",
        url: "totalCostTrend",
        disabled: true,
      },
      {
        name: "Utilization Summery",
        desc:
          "Shows usage (e.g. distance travelled) per vehicle based on meter entries",
        url: "utilizationSummary",
        disabled: true,
      },
      {
        name: "Status Changes",
        desc: "List updates to every vehicle's status",
        url: "statusChanges",
        disabled: true,
      },
      {
        name: "Status Summary",
        desc: "Lists the time vehicles have spent in different statuses",
        url: "statusSummary",
        disabled: true,
      },
      {
        name: "Vehicles Battery Report",
        desc: "Graph that Show Battery Report",
        url: "vehicleBatteryStatus",
        disabled: false,
      },
    ],
    vehicleAssignments: [
      {
        name: "Vehicle Assignment Log",
        desc: "Listing of all vehicle-to-contact assignment details",
        url: "vehicleAssignmentLog",
        disabled: true,
      },
      {
        name: "Vehicle Assignment Summary",
        desc:
          "Aggregate vehicle assignment data grouped by operator or vehicle",
        url: "vehicleAssignmentSummary",
        disabled: true,
      },
    ],

    contacts: [
      {
        name: "User Activity",
        desc: "Users Activity with the system",
        url: "userActivityListReport",
        disabled: false,
      },
      {
        name: "Contact List",
        desc: "Listing of all basic contacts information",
        url: "contactListReport",
        disabled: true,
      },
      {
        name: "Contact Renewal Reminders",
        desc: "Listing of all date based reminders of contacts",
        url: "contactRenewalReport",
        disabled: true,
      },
    ],

    inspections: [
      {
        name: "Inspection Summary",
        desc: "Summary of Inspection Report",
        url: "inspectionSummary",
        disabled: false,
      },
      {
        name: "Inspection Submission List",
        desc: "Listing of all inspection submissions",
        url: "inspectionSubmissionList",
        disabled: true,
      },
      {
        name: "Inspection Submission Summary",
        desc: "Aggregate of data grouped by users or vehicles",
        url: "inspectionSubmissionSummary",
        disabled: true,
      },
      {
        name: "Inspection Failures List",
        desc: "Listing of all failed inspection items",
        url: "inspectionFailuresList",
        disabled: true,
      },
    ],

    services: [
      {
        name: "Service Summary",
        desc: "Listing of summarized service history for vehicles",
        url: "serviceSummary",
        disabled: true,
      },
      {
        name: "Service History by Vehicle",
        desc: "Listing of all service by vehicle grouped by entry or task",
        url: "serviceHistorybyVehicle",
        disabled: true,
      },
      {
        name: "Service Task Summary",
        desc: "Aggregate service data groped by Service Task",
        url: "serviceTaskSummary",
        disabled: true,
      },
      {
        name: "Service Reminders",
        desc: "List all service reminders",
        url: "serviceReminders",
        disabled: true,
      },
      {
        name: "Vehicles Without Service",
        desc: "List all vehicles that haven't had a service task performed",
        url: "vehiclesWithoutService",
        disabled: true,
      },
    ],


    issues: [
      {
        name: "Issues List",
        desc: "List basic details of all vehicles-related issues",
        url: "issueReport",
        disabled: false,
      },
    ],

    fuel: [
      {
        name: "Fuel Summary",
        desc: "Listing of summarized fuel metrics for vehicles",
        url: "fuelSummary",
        disabled: false,
      },
      {
        name: "Expense Summary",
        desc: "Listing of summarized expenses for vehicles",
        url: "expenseSummary",
        disabled: false,
      },
      {
        name: "Fuel Level Sensor",
        desc:
          "Fuel Level Sensor Report",
        url: "fuelLevelSensor",
        disabled: false,
      },
      {
        name: "CANBUS Vehicle Stats",
        desc:
            "Vehicle Detials By CANBUS Vehicle Stats",
        url: "canbusVehicleStats",
        disabled: false,
      },
      {
        name: "Fuel  by Merchant",
        desc:
          "Monthly Detail view of Fuel by Merchant",
        url: "fuelByMerchant",
        disabled: true,
      },
    ],
  },
};

const gettters = {
  getReport: state => getField(state.report_data[state.currentIndex]),
  getCurrentReport: state => state.report_data[state.currentIndex],
}



const mutations = {
  setDownloadState(state, payload){
    state.isDownloadFinished = payload;
  },
  updateReport(state,payload) {
    updateField(state.report_data[state.currentIndex],payload);
  },

  setCurrentIndexByID(state, theID){
    state.currentIndex = state.report_data.findIndex(element => element.id == theID);
  },

  loadAllReports(state, payload) {
    state.report_data = payload.data;
    state.currentIndex = 0;
  },

  addReport(state, payload) {
    state.report_data.push(payload.data);
    state.currentIndex = state.report_data.length -1;
  },

  saveReport(state,payload) {
    state.report_data[state.currentIndex] = payload.data;
  },

  fetchReport(state,payload) {
    if(state.currentIndex == -1){
      state.report_data.push(payload.data);
      state.currentIndex =  0;
    }else{
      state.report_data[state.currentIndex] = payload.data;
    }
  },

  deleteReport(state,payload) {
    state.currentIndex = state.report_data.findIndex(element => element.id == payload.data.id);
    state.report_data.splice(state.currentIndex, 1);
  },

  reset(state) {
    state.report_data = [];
    state.currentIndex = -1;
  }

};


const actions = {
  async loadAllReports({commit}){
    try {
      commit("loadAllReports",await Repository.get(`${MESSAGE_API}`));
    } catch (error){
      console.log(error)
    }
  },

  async addReport({commit}) {
    try {
      commit("addReport",await Repository.get(`${MESSAGE_API}/new`));
    } catch (error){
      console.log(error)
    }
  },

  async saveReport({state,commit}) {
    try {
      commit("saveReport",await Repository.post(`${MESSAGE_API}`,state.report_data[state.currentIndex]));
    } catch (error){
      console.log(error)
    }
  },

  async fetchReport({commit},payloadID) {
    try {
      commit("fetchReport",await Repository.get(`${MESSAGE_API}/${payloadID}`));
    } catch (error){
      console.log(error)
    }
  },

  async deleteReport({commit},payloadID) {
    try {
      commit("deleteReport",await Repository.delete(`${MESSAGE_API}/${payloadID}`));
    } catch (error){
      console.log(error)
    }
  },

  async searchReport({commit},searchTerm) {
    try {
      commit("loadAllReports",await Repository.get(`${MESSAGE_API}/search?q=${searchTerm}`));
    } catch (error){
      console.log(error)
    }
  },



};

export default {
  namespaced: true,
  state,
  gettters,
  mutations,
  actions,
};
